module.exports = __webpack_public_path__ + "static/img/tuanjian.2f0c9c29.png";